export const toUrlId = (id: string) => {
  return id.replaceAll('#', '_')
}

export const fromUrlId = (id: string) => {
  return id.replaceAll('_', '#')
}
